import { render, staticRenderFns } from "./logisticdetails.vue?vue&type=template&id=2e4cf3f4&"
import script from "./logisticdetails.vue?vue&type=script&lang=js&"
export * from "./logisticdetails.vue?vue&type=script&lang=js&"
import style0 from "./logisticdetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports